// Shared authentication types and utilities to avoid dependency cycles
// Re-export the unauthorized handler from the canonical location to avoid dual-registration
import { onUnauthorized } from '../unauthorized-handler';

/**
 * Shared unauthorized handler.
 * References the canonical handler from unauthorized-handler.ts to avoid dual-registration.
 * This is used by hooks and components that need to trigger unauthorized behavior.
 */
export const handleUnauthorized = onUnauthorized;
